import { useInView } from "../../hooks/useInView";
import { namedClients } from "../../utils/clients";

export const CustomerSection = ({ title = "Our Valued Customers" }) => {
  const [ref, inView] = useInView({ threshold: 0.25 });

  // Duplicate for seamless loop
  const marqueeItems = [...namedClients, ...namedClients];

  return (
    <section
      ref={ref}
      className={`px-4 mt-5 mb-5 text-black w-full flex flex-col items-center transition-all duration-700 ease-out transform ${
        inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
      }`}
    >
      <div className="rounded-2xl w-full mt-4">
        <h3 className="lg:text-4xl text-2xl font-bold text-black text-center lg:mb-6 mb-4">{title}</h3>

        <div className="relative overflow-hidden">
          {/* Fade overlays */}
          <div className="absolute inset-y-0 left-0 w-24 pointer-events-none z-10 bg-gradient-to-r from-white to-transparent" />
          <div className="absolute inset-y-0 right-0 w-24 pointer-events-none z-10 bg-gradient-to-l from-white to-transparent" />

          {/* Scrolling logos */}
          <div className="flex animate-marquee gap-0">
            {[0, 1].map(copy => (
              <div key={copy} className="flex flex-shrink-0 items-center gap-8 px-4">
                {namedClients.map(client => (
                  <a
                    key={`${copy}-${client.name}`}
                    href={client.url !== "#" ? client.url : undefined}
                    target={client.url !== "#" ? "_blank" : undefined}
                    rel="noopener noreferrer"
                    className="flex-shrink-0 flex items-center justify-center"
                    title={client.name}
                  >
                    <div
                      className={`h-12 w-28 flex items-center justify-center rounded-lg px-2 ${
                        client.darkBg ? "bg-gray-800" : "bg-gray-50"
                      }`}
                    >
                      <img
                        src={client.logo}
                        alt={client.name}
                        className="max-h-8 max-w-full object-contain"
                      />
                    </div>
                  </a>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
